import { render, staticRenderFns } from "./CTASection.vue?vue&type=template&id=4cb1ced4&"
import script from "./CTASection.ts?vue&type=script&lang=ts&"
export * from "./CTASection.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports